import { safeMatchMedia } from './mobile-helpers';

/**
 * A media query for small screens.
 *
 * Note, this needs to be kept in sync with the $break-small variable in
 * _tokens.scss
 */
export const SmallBreakPoint = safeMatchMedia('(max-width: 66.5rem)');
